import ErrorHandlerComponent from './ErrorHandlerComponent';

export default ErrorHandlerComponent;
